@if (!!item()) {
    <button [cdkCopyToClipboard]="ticketLink()" mat-icon-button>
        <mat-icon>copy</mat-icon>
    </button>
}
